import { createReducer } from "@reduxjs/toolkit";

const initialState = {
	cart: [],
	saleReturn: [],
	purchase: [],
	flexCart: [],
};

export const cartReducer = createReducer(initialState, (builder) => {
	builder
		.addCase('addToCart', (state, action) => {
			const item = action.payload;
			// Check if the item with the same inventoryId already exists
			const isItemExist = state.cart.find((i) => i._id === item._id);
			if (isItemExist) {
				// If it exists, update the existing item
				state.cart = state.cart.map((i) => (i._id === isItemExist._id ? item : i));
			} else {
				// If not, add the new item to the cart
				state.cart.push(item);
			}
		})
		.addCase('removeFromCart', (state, action) => {
			// Remove the item by inventoryId
			state.cart = state.cart.filter((i) => i._id !== action.payload);
		})
		.addCase('addToSaleReturn', (state, action) => {
			const item = action.payload;
			// Check if the item with the same inventoryId already exists
			const isItemExist = state.saleReturn.find((i) => i._id === item._id);
			if (isItemExist) {
				// If it exists, update the existing item
				state.saleReturn = state.saleReturn.map((i) => (i._id === isItemExist._id ? item : i));
			} else {
				// If not, add the new item to the cart
				state.saleReturn.push(item);
			}
		})
		.addCase('removeFromSaleReturn', (state, action) => {
			// Remove the item by inventoryId
			state.saleReturn = state.saleReturn.filter((i) => i._id !== action.payload);
		})
		.addCase('addToPurchase', (state, action) => {
			const item = action.payload;
			// Check if the item with the same inventoryId already exists
			const isItemExist = state.purchase.find((i) => i._id === item._id);
			if (isItemExist) {
				// If it exists, update the existing item
				state.purchase = state.purchase.map((i) => (i._id === isItemExist._id ? item : i));
			} else {
				// If not, add the new item to the purchase
				state.purchase.push(item);
			}
		})
		.addCase('removeFromPurchase', (state, action) => {
			// Remove the item by inventoryId
			state.purchase = state.purchase.filter((i) => i._id !== action.payload);
		})

		// Clear sale return
		.addCase('clearSaleReturn', (state) => {
			state.saleReturn = [];
		})
		// Clear cart
		.addCase('clearCart', (state) => {
			state.cart = [];
		})
		// Clear purchase
		.addCase('clearPurchase', (state) => {
			state.purchase = [];
		})
		.addCase('addToFlexCart', (state, action) => {
			const item = action.payload;
			// Check if the item with the same inventoryId already exists
			const isItemExist = state.flexCart.find((i) => i._id === item._id);
			if (isItemExist) {
				// If it exists, update the existing item
				state.flexCart = state.flexCart.map((i) => (i._id === isItemExist._id ? item : i));
			} else {
				// If not, add the new item to the flexCart
				state.flexCart.push(item);
			}
		})
		.addCase('removeFromFlexCart', (state, action) => {
			// Remove the item by inventoryId
			state.flexCart = state.flexCart.filter((i) => i._id !== action.payload);
		})
		.addCase('clearFlexCart', (state) => {
			state.flexCart = [];
		});
});
